import {Drawer} from 'presentation/components/Drawer';
import React from 'react';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {useDrawerControllerStore} from '../../store/useDrawerControllerStore';
import {ORIENTATION_CARDS} from '../OrientationCardsGrid/constants';
import {SecurityAndBiometrics} from './components/SecutiryAndBiometrics';
import {MedicalBulletin} from './components/MedicalBulletin';
import {ExtendedVisit} from './components/ExtendedVisit';
import {AppMyHospitalization} from './components/AppMyHospitalization';
import {Nutrition} from './components/Nutrition';
import {DischargeGuidelines} from './components/DischargeGuidelines';
import {VisitingHour} from './components/VisitingHour';

export const DrawerOrientations = () => {
	const {isMobile} = useMediaQueries();
	const drawerIndex = useDrawerControllerStore(state => state.drawerIndex);
	const closeDrawer = useDrawerControllerStore(state => state.closeDrawer);

	const renderContent = () => {
		switch (drawerIndex) {
			case 1:
				return <SecurityAndBiometrics />;
			case 2:
				return <MedicalBulletin />;
			case 3:
				return <ExtendedVisit />;
			case 4:
				return <AppMyHospitalization />;
			case 5:
				return <Nutrition />;
			case 6:
				return <DischargeGuidelines />;
			case 7:
				return <VisitingHour />;
			default:
				return null;
		}
	};

	return (
		<Drawer.Root
			data-test-id="orientations-drawer"
			onClose={closeDrawer}
			onOpen={() => null}
			open={!!drawerIndex}>
			<Drawer.Header
				title={ORIENTATION_CARDS.find(card => card.id === drawerIndex)?.title}
				onClose={closeDrawer}
				fontSize={'18px'}
				lineHeight={'28.8px'}
				containerPadding={isMobile ? '0 16px 16px' : '0 24px 16px'}
			/>
			<Drawer.Content>{renderContent()}</Drawer.Content>
		</Drawer.Root>
	);
};
